"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpScheduleOverview = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const consts_1 = require("@opsbase/lib-time/consts");
const shiftTZUTCToLocal_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZUTCToLocal"));
const RepetitionType_1 = __importDefault(require("@opsbase/lib-time/RepetitionType"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const EditIcon_1 = __importDefault(require("@opsbase/web-icons/icons/EditIcon"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importDefault(require("react"));
const calcPlaceLabel_1 = __importDefault(require("../helpers/calcPlaceLabel"));
const calcRepetitionLabels_1 = __importDefault(require("../helpers/calcRepetitionLabels"));
const calcTimeLabel_1 = __importDefault(require("../helpers/calcTimeLabel"));
const useOpScheduleCalendarSelection_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarSelection"));
const makeMyClasses = open => ({
    root: {
        position: 'absolute',
        bottom: 0,
        maxHeight: open ? 400 : 0,
        left: 0,
        right: 0,
        zIndex: 2,
        borderRadius: 4,
        overflow: 'hidden',
        backgroundColor: lib_palette_1.default.White.main,
        border: open ? `1px solid ${lib_palette_1.default.InputBorderGrey.main}` : undefined,
        transition: 'max-height 0.3s',
    },
    deleteButton: {
        position: 'absolute',
        bottom: 8,
        right: 8,
        zIndex: 3,
    },
    txt: {
        display: 'block',
        marginLeft: 8,
        color: lib_palette_1.default.secondary.main,
        fontSize: 12,
        lineHeight: '18px',
    },
    subtxt: {
        display: 'block',
        marginLeft: 8,
        color: lib_palette_1.default.GreyBlue.main,
        fontSize: 12,
        lineHeight: '16px',
    },
});
function OpScheduleOverview(props) {
    const { onEdit, onDelete, isEditable = true } = props;
    const { selectedSchedule, selectedEvent } = (0, useOpScheduleCalendarSelection_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses, [!!selectedSchedule]);
    return (react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.root } },
        react_1.default.createElement(IconButton_1.default, { classes: { root: myCss.deleteButton }, icon: react_1.default.createElement(DeleteIcon_1.default, { color: lib_palette_1.default.BadRed }), disabled: !isEditable, onClick: onDelete }),
        react_1.default.createElement(Pane_1.default, { padding: true },
            react_1.default.createElement(Button_1.default, { icon: react_1.default.createElement(EditIcon_1.default, null), color: lib_palette_1.default.primary, fullWidth: true, disabled: !isEditable, label: lib_i18n_1.default.t('edit'), onClick: onEdit })),
        react_1.default.createElement(Pane_1.default, { grow: true }, !!selectedSchedule && (react_1.default.createElement(OpScheduleOverviewInner, { opSchedule: selectedSchedule, calendarEvent: selectedEvent })))));
}
exports.OpScheduleOverview = OpScheduleOverview;
function OpScheduleOverviewInner({ opSchedule, calendarEvent, }) {
    const { dueDate, repetitionType, whenCanView, whenCanStart, whenIsMissed } = opSchedule;
    const hasEvent = !!calendarEvent;
    const utcDue = dueDate ? (0, shiftTZUTCToLocal_1.default)(dueDate) : undefined;
    let eventDueDate = utcDue;
    let eventStartable, eventViewable, eventMissed;
    if (hasEvent) {
        const { end } = calendarEvent;
        eventDueDate = (0, moment_timezone_1.default)(end);
        eventStartable = eventDueDate.clone().subtract(whenCanStart, 'minutes');
        eventViewable = eventDueDate.clone().subtract(whenCanView, 'minutes');
        eventMissed = eventDueDate.clone().add(whenIsMissed, 'minutes');
    }
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const whereText = (0, calcPlaceLabel_1.default)(opSchedule);
    const repeatTxt = (0, calcRepetitionLabels_1.default)(opSchedule, false, true)[repetitionType];
    const dueText = hasEvent
        ? eventDueDate.format(consts_1.DateTimeFormat)
        : repetitionType === RepetitionType_1.default.NEVER
            ? utcDue.format(consts_1.DateTimeFormat)
            : utcDue.format(consts_1.SimpleTimeFormat);
    const viewableLabel = (0, calcTimeLabel_1.default)(whenCanView) + ' ' + lib_i18n_1.default.t('before-due');
    const viewableText = hasEvent ? eventViewable.format(consts_1.DateTimeFormat) : viewableLabel;
    const viewableSubText = hasEvent ? viewableLabel : undefined;
    const startableLabel = (0, calcTimeLabel_1.default)(whenCanStart) + ' ' + lib_i18n_1.default.t('before-due');
    const startableText = hasEvent ? eventStartable.format(consts_1.DateTimeFormat) : startableLabel;
    const startableSubText = hasEvent ? startableLabel : undefined;
    const missedLabel = (0, calcTimeLabel_1.default)(whenIsMissed) + ' ' + lib_i18n_1.default.t('after-due');
    const missedText = hasEvent ? eventMissed.format(consts_1.DateTimeFormat) : missedLabel;
    const missedSubText = hasEvent ? missedLabel : undefined;
    return (react_1.default.createElement(Vertical_1.default, { scrollY: true, padding: true, gutter: true },
        react_1.default.createElement(Pane_1.default, null, !!utcDue && (react_1.default.createElement(Text_1.default, { variant: "h2" },
            lib_i18n_1.default.t('where'),
            react_1.default.createElement("span", { className: myCss.txt }, whereText)))),
        react_1.default.createElement(Pane_1.default, null, !!utcDue && (react_1.default.createElement(Text_1.default, { variant: "h2" },
            lib_i18n_1.default.t('due'),
            react_1.default.createElement("span", { className: myCss.txt }, dueText)))),
        react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(Text_1.default, { variant: "h2" },
                lib_i18n_1.default.t('repeat'),
                react_1.default.createElement("span", { className: myCss.txt }, repeatTxt))),
        react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(Text_1.default, null,
                lib_i18n_1.default.t('visible-in-todo'),
                react_1.default.createElement("span", { className: myCss.txt }, viewableText),
                !!viewableSubText && react_1.default.createElement("span", { className: myCss.subtxt }, viewableSubText))),
        react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(Text_1.default, null,
                lib_i18n_1.default.t('can-be-started'),
                react_1.default.createElement("span", { className: myCss.txt }, startableText),
                !!startableSubText && react_1.default.createElement("span", { className: myCss.subtxt }, startableSubText))),
        react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(Text_1.default, null,
                lib_i18n_1.default.t('missed-if-not-submitted'),
                react_1.default.createElement("span", { className: myCss.txt }, missedText),
                !!missedSubText && react_1.default.createElement("span", { className: myCss.subtxt }, missedSubText)))));
}
exports.default = OpScheduleOverview;
